module.exports = __webpack_public_path__ + "static/media/sell_cancel_3.7ad0f341.jpg";